(function (factory) {
  if (typeof module === 'object' && module.exports) {
    module.exports = factory;
  } else {
    factory(Highcharts);
  }
}(function (Highcharts) {

  Highcharts.maps["countries/in/custom/in-all-disputed"] = {
    "title": "India with disputed territories",
    "version": "1.1.2",
    "type": "FeatureCollection",
    "copyright": "Copyright (c) 2015 Highsoft AS, Based on data from Natural Earth",
    "copyrightShort": "Natural Earth",
    "copyrightUrl": "http://www.naturalearthdata.com",
    "crs": {"type": "name", "properties": {"name": "urn:ogc:def:crs:EPSG:32644"}},
    "hc-transform": {
      "default": {
        "crs": "+proj=utm +zone=44 +datum=WGS84 +units=m +no_defs",
        "scale": 0.000208639199523,
        "jsonres": 15.5,
        "jsonmarginX": -999,
        "jsonmarginY": 9851.0,
        "xoffset": -817769.399432,
        "yoffset": 4119749.63848
      }
    },
    "features": [{
      "type": "Feature",
      "id": "IN.AN",
      "properties": {
        "hc-group": "admin1",
        "hc-middle-x": 0.22,
        "hc-middle-y": 0.16,
        "hc-key": "in-an",
        "hc-a2": "AN",
        "labelrank": "2",
        "hasc": "IN.AN",
        "alt-name": "Andaman & Nicobar Islands|Andaman et Nicobar|Iihas de Andama e Nicobar|Inseln Andamanen und Nikobare",
        "woe-id": "2345739",
        "subregion": null,
        "fips": "IN01",
        "postal-code": "AN",
        "name": "Andaman and Nicobar",
        "country": "India",
        "type-en": "Union Territory",
        "region": null,
        "longitude": "93.7895",
        "woe-name": "Andaman and Nicobar",
        "latitude": "6.83654",
        "woe-label": "Andaman and Nicobar Islands, IN, India",
        "type": "Union Territor"
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [[[[7890, -827], [7919, -900], [7907, -978], [7887, -999], [7842, -910], [7817, -903], [7825, -841], [7890, -827]]], [[[7728, -561], [7737, -592], [7681, -564], [7712, -539], [7728, -561]]], [[[7759, -541], [7750, -521], [7730, -484], [7758, -460], [7759, -541]]], [[[7384, 464], [7384, 388], [7363, 360], [7313, 371], [7326, 403], [7310, 459], [7362, 502], [7384, 464]]], [[[7528, 956], [7522, 918], [7541, 876], [7497, 907], [7528, 956]]], [[[7486, 1267], [7456, 1242], [7488, 1227], [7504, 1101], [7474, 983], [7427, 936], [7422, 893], [7445, 859], [7437, 769], [7398, 673], [7378, 803], [7352, 866], [7382, 860], [7384, 956], [7398, 987], [7438, 984], [7409, 1039], [7406, 1126], [7427, 1151], [7408, 1202], [7430, 1221], [7446, 1360], [7436, 1392], [7470, 1471], [7504, 1486], [7513, 1426], [7495, 1397], [7523, 1373], [7505, 1289], [7486, 1267]]]]
      }
    }, {
      "type": "Feature",
      "id": "IN.WB",
      "properties": {
        "hc-group": "admin1",
        "hc-middle-x": 0.50,
        "hc-middle-y": 0.74,
        "hc-key": "in-wb",
        "hc-a2": "WB",
        "labelrank": "2",
        "hasc": "IN.WB",
        "alt-name": "Bangla|Bengala Occidentale|Bengala Ocidental|Bengale occidental",
        "woe-id": "2345761",
        "subregion": null,
        "fips": "IN28",
        "postal-code": "WB",
        "name": "West Bengal",
        "country": "India",
        "type-en": "State",
        "region": "East",
        "longitude": "87.7289",
        "woe-name": "West Bengal",
        "latitude": "23.0523",
        "woe-label": "West Bengal, IN, India",
        "type": "State"
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [[[[5641, 4401], [5663, 4368], [5653, 4317], [5627, 4321], [5641, 4401]]], [[[5549, 6084], [5572, 6160], [5537, 6247], [5500, 6285], [5508, 6338], [5547, 6301], [5630, 6286], [5675, 6322], [5745, 6316], [5798, 6258], [5870, 6205], [5948, 6223], [6037, 6197], [6034, 6180], [6119, 6186], [6133, 6119], [6119, 6043], [6067, 5989], [6037, 5971], [6036, 5908], [5971, 5914], [5897, 5958], [5881, 6030], [5831, 6064], [5814, 6038], [5864, 5997], [5789, 5988], [5736, 6050], [5649, 6097], [5624, 6068], [5672, 6061], [5628, 5968], [5582, 5942], [5558, 5857], [5577, 5810], [5609, 5822], [5675, 5772], [5714, 5718], [5763, 5709], [5793, 5724], [5822, 5662], [5864, 5656], [5850, 5606], [5743, 5609], [5689, 5599], [5689, 5555], [5656, 5487], [5618, 5513], [5564, 5402], [5606, 5350], [5720, 5291], [5773, 5286], [5812, 5263], [5790, 5236], [5807, 5155], [5768, 5131], [5754, 5052], [5817, 4990], [5833, 4991], [5810, 4926], [5819, 4908], [5901, 4892], [5869, 4851], [5868, 4811], [5904, 4771], [5894, 4731], [5963, 4522], [5961, 4445], [5944, 4432], [5974, 4350], [5947, 4323], [5906, 4346], [5868, 4302], [5839, 4351], [5848, 4475], [5803, 4299], [5777, 4290], [5785, 4395], [5761, 4370], [5763, 4321], [5728, 4342], [5695, 4294], [5669, 4339], [5675, 4383], [5653, 4437], [5677, 4481], [5655, 4508], [5596, 4390], [5509, 4321], [5434, 4303], [5408, 4364], [5363, 4372], [5333, 4422], [5289, 4403], [5268, 4451], [5160, 4509], [5213, 4545], [5167, 4600], [5177, 4628], [5130, 4647], [5121, 4674], [5057, 4709], [5071, 4789], [4968, 4794], [4926, 4837], [4882, 4839], [4861, 4874], [4881, 4930], [4858, 4953], [4914, 4966], [4922, 5000], [4957, 4991], [4987, 4946], [5026, 4968], [5065, 5017], [5176, 5052], [5199, 5121], [5268, 5089], [5321, 5104], [5330, 5146], [5399, 5178], [5397, 5206], [5454, 5231], [5442, 5260], [5471, 5279], [5494, 5346], [5476, 5379], [5518, 5379], [5514, 5488], [5477, 5558], [5476, 5602], [5492, 5626], [5459, 5670], [5526, 5720], [5563, 5707], [5553, 5770], [5471, 5840], [5477, 5890], [5522, 5941], [5623, 6024], [5584, 6090], [5549, 6084]]]]
      }
    }, {
      "type": "Feature",
      "id": "IN.LD",
      "properties": {
        "hc-group": "admin1",
        "hc-middle-x": 0.60,
        "hc-middle-y": 0.63,
        "hc-key": "in-ld",
        "hc-a2": "LD",
        "labelrank": "2",
        "hasc": "IN.LD",
        "alt-name": "Ãles Laquedives|Laccadive|Minicoy and Amindivi Islands|Laccadives|Lackadiverna|Lakkadiven|Lakkadi",
        "woe-id": "2345748",
        "subregion": null,
        "fips": "IN14",
        "postal-code": "LD",
        "name": "Lakshadweep",
        "country": "India",
        "type-en": "Union Territory",
        "region": "South",
        "longitude": "72.7811",
        "woe-name": "Lakshadweep",
        "latitude": "11.2249",
        "woe-label": "Lakshadweep, IN, India",
        "type": "Union Territor"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [[[425, -491], [413, -492], [427, -484], [435, -474], [425, -491]]]
      }
    }, {
      "type": "Feature",
      "id": "IN.5390",
      "properties": {
        "hc-group": "admin1",
        "hc-middle-x": 0.54,
        "hc-middle-y": 0.46,
        "hc-key": "in-5390",
        "hc-a2": "NU",
        "labelrank": "20",
        "hasc": "-99",
        "alt-name": null,
        "woe-id": "-99",
        "subregion": null,
        "fips": null,
        "postal-code": null,
        "name": null,
        "country": "India",
        "type-en": null,
        "region": null,
        "longitude": "79.0729",
        "woe-name": null,
        "latitude": "9.19759",
        "woe-label": null,
        "type": null
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [[[2579, -182], [2581, -185], [2573, -181], [2575, -180], [2579, -182]]]
      }
    }, {
      "type": "Feature",
      "id": "IN.PY",
      "properties": {
        "hc-group": "admin1",
        "hc-middle-x": 0.64,
        "hc-middle-y": 0.81,
        "hc-key": "in-py",
        "hc-a2": "PY",
        "labelrank": "2",
        "hasc": "IN.PY",
        "alt-name": "Pondicherry|Puduchcheri|PondichÃ©ry",
        "woe-id": "20070459",
        "subregion": null,
        "fips": "IN22",
        "postal-code": "PY",
        "name": "Puducherry",
        "country": "India",
        "type-en": "Union Territory",
        "region": "South",
        "longitude": "79.7758",
        "woe-name": "Puducherry",
        "latitude": "10.9224",
        "woe-label": "Puducherry, IN, India",
        "type": "Union Territor"
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [[[[3693, 2498], [3669, 2507], [3687, 2507], [3711, 2512], [3693, 2498]]], [[[2855, 454], [2853, 443], [2855, 393], [2805, 429], [2816, 456], [2855, 454]]], [[[2857, 803], [2847, 776], [2844, 759], [2806, 768], [2800, 819], [2857, 803]]], [[[1255, 854], [1240, 844], [1226, 847], [1226, 875], [1288, 890], [1255, 854]]]]
      }
    }, {
      "type": "Feature",
      "id": "IN.3464",
      "properties": {
        "hc-group": "admin1",
        "hc-middle-x": 0.98,
        "hc-middle-y": 0.90,
        "hc-key": "in-3464",
        "hc-a2": "DA",
        "labelrank": "2",
        "hasc": "IN.",
        "alt-name": null,
        "woe-id": "20070460",
        "subregion": null,
        "fips": "IN32",
        "postal-code": null,
        "name": "Daman and Diu",
        "country": "India",
        "type-en": null,
        "region": "West",
        "longitude": "72.8511",
        "woe-name": "Daman and Diu",
        "latitude": "20.4226",
        "woe-label": "Daman and Diu, IN, India",
        "type": null
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [[[[494, 3885], [499, 3906], [506, 3916], [516, 3888], [494, 3885]]], [[[-115, 4048], [-117, 4043], [-127, 4039], [-123, 4050], [-115, 4048]]]]
      }
    }, {
      "type": "Feature",
      "id": "IN.MZ",
      "properties": {
        "hc-group": "admin1",
        "hc-middle-x": 0.53,
        "hc-middle-y": 0.38,
        "hc-key": "in-mz",
        "hc-a2": "MZ",
        "labelrank": "2",
        "hasc": "IN.MZ",
        "alt-name": null,
        "woe-id": "20070461",
        "subregion": null,
        "fips": "IN31",
        "postal-code": "MZ",
        "name": "Mizoram",
        "country": "India",
        "type-en": "State",
        "region": "Northeast",
        "longitude": "92.84090000000001",
        "woe-name": "Mizoram",
        "latitude": "23.2037",
        "woe-label": "Mizoram, IN, India",
        "type": "State"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [[[7329, 5304], [7363, 5198], [7385, 5167], [7382, 4977], [7360, 4934], [7306, 4925], [7323, 4881], [7294, 4838], [7308, 4744], [7334, 4700], [7332, 4627], [7292, 4629], [7283, 4553], [7239, 4560], [7178, 4603], [7171, 4553], [7146, 4536], [7141, 4605], [7099, 4795], [7043, 4887], [7029, 4963], [7035, 5006], [6991, 5120], [6991, 5154], [7006, 5209], [6999, 5332], [6988, 5349], [7027, 5353], [7043, 5315], [7097, 5358], [7130, 5446], [7160, 5414], [7223, 5428], [7225, 5317], [7263, 5302], [7329, 5304]]]
      }
    }, {
      "type": "Feature",
      "id": "IN.AS",
      "properties": {
        "hc-group": "admin1",
        "hc-middle-x": 0.53,
        "hc-middle-y": 0.46,
        "hc-key": "in-as",
        "hc-a2": "AS",
        "labelrank": "2",
        "hasc": "IN.AS",
        "alt-name": null,
        "woe-id": "2345741",
        "subregion": null,
        "fips": "IN03",
        "postal-code": "AS",
        "name": "Assam",
        "country": "India",
        "type-en": "State",
        "region": "Northeast",
        "longitude": "92.99290000000001",
        "woe-name": "Assam",
        "latitude": "26.3302",
        "woe-label": "Assam, IN, India",
        "type": "State"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [[[6119, 6186], [6193, 6199], [6219, 6233], [6284, 6260], [6353, 6224], [6396, 6223], [6551, 6248], [6577, 6240], [6616, 6278], [6656, 6255], [6714, 6262], [6774, 6296], [6821, 6290], [6833, 6315], [6876, 6316], [7068, 6384], [7138, 6355], [7252, 6379], [7281, 6367], [7355, 6396], [7395, 6433], [7397, 6471], [7513, 6604], [7509, 6648], [7586, 6637], [7845, 6778], [7919, 6790], [7971, 6829], [8051, 6840], [8003, 6731], [8046, 6677], [8055, 6620], [8081, 6642], [8094, 6612], [8064, 6575], [7981, 6548], [7948, 6560], [7913, 6507], [7837, 6459], [7794, 6417], [7756, 6419], [7690, 6334], [7626, 6304], [7591, 6234], [7560, 6252], [7537, 6182], [7488, 6108], [7491, 6021], [7466, 5985], [7426, 5972], [7430, 6013], [7290, 5851], [7336, 5798], [7336, 5769], [7336, 5769], [7336, 5769], [7336, 5769], [7320, 5743], [7266, 5582], [7244, 5580], [7244, 5495], [7223, 5428], [7160, 5414], [7130, 5446], [7097, 5358], [7043, 5315], [7027, 5353], [6988, 5349], [6961, 5356], [6970, 5405], [6930, 5455], [6953, 5589], [6997, 5568], [7029, 5605], [6994, 5629], [7048, 5688], [7125, 5722], [7116, 5766], [7045, 5815], [7044, 5847], [6969, 5905], [6900, 5875], [6920, 6007], [6887, 6016], [6810, 5991], [6776, 6007], [6745, 5960], [6699, 5978], [6668, 5915], [6632, 5905], [6585, 5863], [6577, 5910], [6524, 5894], [6502, 5932], [6434, 5932], [6361, 5909], [6361, 5935], [6304, 5943], [6228, 5917], [6179, 5857], [6172, 5816], [6194, 5780], [6134, 5722], [6138, 5793], [6117, 5866], [6130, 5901], [6067, 5989], [6119, 6043], [6133, 6119], [6119, 6186]]]
      }
    }, {
      "type": "Feature",
      "id": "IN.PB",
      "properties": {
        "hc-group": "admin1",
        "hc-middle-x": 0.52,
        "hc-middle-y": 0.53,
        "hc-key": "in-pb",
        "hc-a2": "PB",
        "labelrank": "2",
        "hasc": "IN.PB",
        "alt-name": null,
        "woe-id": "2345756",
        "subregion": null,
        "fips": "IN23",
        "postal-code": "PB",
        "name": "Punjab",
        "country": "India",
        "type-en": "State",
        "region": "North",
        "longitude": "75.3762",
        "woe-name": "Punjab",
        "latitude": "31.0245",
        "woe-label": "Punjab, IN, India",
        "type": "State"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [[[1064, 7402], [1035, 7458], [1106, 7518], [1199, 7645], [1221, 7641], [1305, 7705], [1259, 7741], [1298, 7834], [1266, 7934], [1292, 7979], [1376, 8041], [1443, 8063], [1483, 8057], [1521, 8077], [1543, 8117], [1526, 8143], [1569, 8151], [1588, 8128], [1697, 8201], [1715, 8169], [1645, 8115], [1608, 8052], [1697, 8005], [1721, 7959], [1708, 7944], [1749, 7855], [1772, 7773], [1808, 7762], [1840, 7799], [1857, 7762], [1901, 7729], [1917, 7645], [1954, 7611], [1973, 7587], [1967, 7568], [1933, 7566], [1969, 7529], [1991, 7499], [1990, 7421], [1933, 7433], [1930, 7407], [1872, 7372], [1904, 7360], [1869, 7318], [1828, 7356], [1822, 7333], [1776, 7342], [1757, 7276], [1767, 7241], [1684, 7202], [1632, 7237], [1574, 7216], [1525, 7233], [1455, 7149], [1438, 7195], [1459, 7216], [1410, 7270], [1386, 7264], [1334, 7307], [1278, 7285], [1237, 7299], [1041, 7324], [1070, 7378], [1064, 7402]]]
      }
    }, {
      "type": "Feature",
      "id": "IN.GA",
      "properties": {
        "hc-group": "admin1",
        "hc-middle-x": 0.60,
        "hc-middle-y": 0.47,
        "hc-key": "in-ga",
        "hc-a2": "GA",
        "labelrank": "2",
        "hasc": "IN.GA",
        "alt-name": "GÃ´a",
        "woe-id": "2345764",
        "subregion": null,
        "fips": "IN08",
        "postal-code": "GA",
        "name": "Goa",
        "country": "India",
        "type-en": "State",
        "region": "West",
        "longitude": "73.99509999999999",
        "woe-name": "Goa",
        "latitude": "15.3133",
        "woe-label": "Goa, IN, India",
        "type": "State"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [[[854, 1888], [794, 1959], [807, 1988], [790, 2054], [758, 2094], [728, 2194], [772, 2214], [811, 2158], [866, 2159], [910, 2154], [931, 2025], [907, 1911], [854, 1888]]]
      }
    }, {
      "type": "Feature",
      "id": "IN.2984",
      "properties": {
        "hc-group": "admin1",
        "hc-middle-x": 0.51,
        "hc-middle-y": 0.29,
        "hc-key": "in-2984",
        "hc-a2": "GU",
        "labelrank": "2",
        "hasc": "IN.",
        "alt-name": null,
        "woe-id": "2345743",
        "subregion": null,
        "fips": "IN32",
        "postal-code": null,
        "name": "Gujarat",
        "country": "India",
        "type-en": null,
        "region": "West",
        "longitude": "71.3013",
        "woe-name": "Gujarat",
        "latitude": "22.7501",
        "woe-label": "Gujarat, IN, India",
        "type": null
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [[[451, 3776], [469, 3850], [494, 3885], [516, 3888], [506, 3916], [528, 4011], [520, 4071], [467, 4138], [477, 4182], [439, 4209], [427, 4252], [448, 4288], [555, 4354], [450, 4359], [423, 4371], [458, 4461], [418, 4466], [435, 4531], [467, 4548], [504, 4530], [539, 4555], [441, 4576], [386, 4569], [391, 4609], [357, 4562], [355, 4507], [292, 4476], [303, 4424], [248, 4433], [252, 4403], [301, 4407], [342, 4354], [320, 4293], [270, 4235], [268, 4196], [43, 4093], [-115, 4048], [-123, 4050], [-127, 4039], [-172, 4039], [-272, 4084], [-339, 4132], [-428, 4219], [-561, 4399], [-698, 4543], [-775, 4664], [-761, 4703], [-683, 4695], [-685, 4649], [-590, 4669], [-566, 4705], [-546, 4668], [-503, 4710], [-486, 4688], [-424, 4725], [-351, 4729], [-275, 4847], [-221, 4888], [-239, 4927], [-266, 4862], [-321, 4886], [-332, 4870], [-459, 4845], [-501, 4808], [-659, 4855], [-779, 4930], [-856, 4999], [-857, 5048], [-915, 5098], [-892, 5121], [-907, 5165], [-767, 5243], [-832, 5232], [-911, 5191], [-942, 5152], [-999, 5162], [-957, 5182], [-991, 5215], [-982, 5250], [-895, 5287], [-797, 5278], [-786, 5395], [-730, 5402], [-708, 5377], [-602, 5377], [-508, 5367], [-475, 5332], [-375, 5315], [-325, 5362], [-186, 5395], [-176, 5344], [-113, 5319], [-56, 5362], [0, 5376], [-33, 5398], [-38, 5442], [-1, 5479], [62, 5454], [160, 5466], [292, 5447], [328, 5462], [444, 5385], [453, 5354], [489, 5378], [550, 5329], [608, 5319], [636, 5365], [662, 5369], [678, 5305], [656, 5259], [707, 5188], [745, 5218], [765, 5158], [741, 5102], [823, 5025], [822, 4973], [884, 4969], [931, 4939], [1019, 4862], [1047, 4817], [1058, 4759], [1088, 4732], [1058, 4678], [984, 4633], [938, 4622], [1003, 4572], [952, 4572], [949, 4519], [970, 4473], [964, 4430], [855, 4394], [858, 4326], [832, 4313], [853, 4275], [913, 4289], [1012, 4270], [898, 4232], [883, 4196], [843, 4194], [804, 4138], [861, 4082], [871, 4010], [829, 3951], [773, 3938], [716, 3996], [685, 3970], [715, 3931], [679, 3872], [676, 3803], [645, 3810], [608, 3784], [578, 3865], [518, 3827], [534, 3792], [473, 3785], [451, 3776]]]
      }
    }, {
      "type": "Feature",
      "id": "IN.JK",
      "properties": {
        "hc-group": "admin1",
        "hc-middle-x": 0.58,
        "hc-middle-y": 0.56,
        "hc-key": "in-jk",
        "hc-a2": "JK",
        "labelrank": "2",
        "hasc": "IN.JK",
        "alt-name": null,
        "woe-id": "2345746",
        "subregion": null,
        "fips": "IN12",
        "postal-code": "JK",
        "name": "Jammu and Kashmir",
        "country": "India",
        "type-en": "State",
        "region": "North",
        "longitude": "76.6395",
        "woe-name": "Jammu and Kashmir",
        "latitude": "33.9658",
        "woe-label": "Jammu and Kashmir, IN, India",
        "type": "State"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [[[1697, 8201], [1588, 8128], [1569, 8151], [1526, 8143], [1445, 8196], [1354, 8199], [1327, 8246], [1350, 8333], [1298, 8305], [1140, 8396], [1092, 8415], [1034, 8459], [1026, 8555], [1044, 8577], [1042, 8743], [1026, 8779], [1020, 8874], [1001, 8914], [1019, 8979], [1072, 8977], [1118, 9056], [1196, 9081], [1234, 9159], [1178, 9199], [1121, 9207], [1111, 9243], [1143, 9291], [1138, 9320], [1036, 9336], [960, 9402], [950, 9462], [867, 9455], [784, 9485], [808, 9523], [794, 9557], [809, 9602], [847, 9613], [937, 9678], [974, 9723], [972, 9758], [1071, 9769], [1203, 9744], [1203, 9770], [1161, 9813], [1227, 9785], [1270, 9782], [1360, 9835], [1401, 9820], [1439, 9851], [1509, 9813], [1564, 9821], [1635, 9789], [1648, 9727], [1695, 9731], [1757, 9700], [1807, 9610], [1856, 9600], [1880, 9561], [1923, 9555], [1934, 9529], [2003, 9508], [2028, 9478], [2031, 9406], [2096, 9371], [2119, 9341], [2194, 9331], [2229, 9306], [2241, 9242], [2350, 9240], [2370, 9268], [2417, 9261], [2425, 9283], [2513, 9336], [2545, 9342], [2592, 9386], [2662, 9381], [2764, 9408], [2803, 9394], [2805, 9364], [2865, 9343], [2872, 9291], [2943, 9275], [2967, 9213], [2998, 9207], [3035, 9250], [3077, 9221], [3044, 9166], [3047, 9124], [3019, 9080], [3020, 9018], [2981, 8937], [2922, 8928], [2881, 8889], [2867, 8843], [2819, 8838], [2830, 8788], [2814, 8736], [2778, 8703], [2646, 8703], [2631, 8682], [2661, 8611], [2663, 8564], [2631, 8565], [2636, 8481], [2652, 8453], [2774, 8399], [2759, 8325], [2808, 8248], [2800, 8212], [2739, 8158], [2689, 8152], [2677, 8116], [2627, 8111], [2585, 8150], [2569, 8214], [2543, 8193], [2467, 8177], [2433, 8169], [2466, 8220], [2465, 8262], [2355, 8209], [2312, 8305], [2272, 8356], [2158, 8308], [2094, 8331], [2041, 8369], [1978, 8433], [1924, 8447], [1843, 8421], [1817, 8387], [1741, 8340], [1690, 8338], [1720, 8292], [1721, 8236], [1697, 8201]]]
      }
    }, {
      "type": "Feature",
      "id": "IN.HR",
      "properties": {
        "hc-group": "admin1",
        "hc-middle-x": 0.53,
        "hc-middle-y": 0.63,
        "hc-key": "in-hr",
        "hc-a2": "HR",
        "labelrank": "2",
        "hasc": "IN.HR",
        "alt-name": null,
        "woe-id": "2345744",
        "subregion": null,
        "fips": "IN10",
        "postal-code": "HR",
        "name": "Haryana",
        "country": "India",
        "type-en": "State",
        "region": "Central",
        "longitude": "76.271",
        "woe-name": "Haryana",
        "latitude": "29.1003",
        "woe-label": "Haryana, IN, India",
        "type": "State"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [[[1237, 7299], [1278, 7285], [1334, 7307], [1386, 7264], [1410, 7270], [1459, 7216], [1438, 7195], [1455, 7149], [1525, 7233], [1574, 7216], [1632, 7237], [1684, 7202], [1767, 7241], [1757, 7276], [1776, 7342], [1822, 7333], [1828, 7356], [1869, 7318], [1904, 7360], [1872, 7372], [1930, 7407], [1933, 7433], [1990, 7421], [1991, 7499], [1969, 7529], [1970, 7548], [1967, 7568], [1973, 7587], [1954, 7611], [1997, 7606], [2025, 7561], [2059, 7540], [2062, 7485], [2083, 7460], [2201, 7414], [2195, 7377], [2086, 7272], [2068, 7210], [2027, 7122], [2054, 7067], [2048, 6969], [2064, 6878], [2022, 6881], [1980, 6858], [1982, 6815], [1945, 6772], [1956, 6753], [2019, 6754], [2057, 6718], [2100, 6748], [2152, 6701], [2161, 6651], [2140, 6577], [2158, 6543], [2077, 6494], [2001, 6496], [2010, 6471], [1958, 6448], [1973, 6610], [1947, 6649], [1879, 6600], [1847, 6560], [1816, 6592], [1818, 6630], [1732, 6601], [1722, 6582], [1738, 6517], [1669, 6520], [1650, 6562], [1681, 6606], [1655, 6620], [1700, 6638], [1642, 6723], [1609, 6734], [1552, 6813], [1514, 6952], [1480, 7052], [1400, 7034], [1322, 7098], [1255, 7077], [1233, 7117], [1254, 7126], [1257, 7234], [1218, 7227], [1245, 7268], [1237, 7299]]]
      }
    }, {
      "type": "Feature",
      "id": "IN.NL",
      "properties": {
        "hc-group": "admin1",
        "hc-middle-x": 0.78,
        "hc-middle-y": 0.63,
        "hc-key": "in-nl",
        "hc-a2": "NL",
        "labelrank": "2",
        "hasc": "IN.NL",
        "alt-name": null,
        "woe-id": "2345754",
        "subregion": null,
        "fips": "IN20",
        "postal-code": "NL",
        "name": "Nagaland",
        "country": "India",
        "type-en": "State",
        "region": "Northeast",
        "longitude": "94.5664",
        "woe-name": "Nagaland",
        "latitude": "26.1094",
        "woe-label": "Nagaland, IN, India",
        "type": "State"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [[[7876, 6321], [7836, 6300], [7816, 6250], [7827, 6167], [7869, 6099], [7825, 6047], [7835, 5980], [7764, 5881], [7728, 5861], [7687, 5882], [7693, 5946], [7618, 5874], [7580, 5864], [7517, 5879], [7444, 5868], [7449, 5833], [7391, 5739], [7336, 5769], [7336, 5769], [7336, 5769], [7336, 5769], [7336, 5798], [7290, 5851], [7430, 6013], [7426, 5972], [7466, 5985], [7491, 6021], [7488, 6108], [7537, 6182], [7560, 6252], [7591, 6234], [7626, 6304], [7690, 6334], [7756, 6419], [7794, 6417], [7837, 6459], [7853, 6399], [7876, 6321]]]
      }
    }, {
      "type": "Feature",
      "id": "IN.MN",
      "properties": {
        "hc-group": "admin1",
        "hc-middle-x": 0.51,
        "hc-middle-y": 0.48,
        "hc-key": "in-mn",
        "hc-a2": "MN",
        "labelrank": "2",
        "hasc": "IN.MN",
        "alt-name": null,
        "woe-id": "2345751",
        "subregion": null,
        "fips": "IN17",
        "postal-code": "MN",
        "name": "Manipur",
        "country": "India",
        "type-en": "State",
        "region": "Northeast",
        "longitude": "93.84569999999999",
        "woe-name": "Manipur",
        "latitude": "24.7442",
        "woe-label": "Manipur, IN, India",
        "type": "State"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [[[7223, 5428], [7244, 5495], [7244, 5580], [7266, 5582], [7320, 5743], [7336, 5769], [7336, 5769], [7391, 5739], [7449, 5833], [7444, 5868], [7517, 5879], [7580, 5864], [7618, 5874], [7693, 5946], [7687, 5882], [7728, 5861], [7702, 5784], [7752, 5750], [7763, 5710], [7734, 5604], [7711, 5586], [7649, 5437], [7627, 5317], [7602, 5258], [7566, 5282], [7500, 5283], [7433, 5304], [7383, 5281], [7350, 5322], [7329, 5304], [7263, 5302], [7225, 5317], [7223, 5428]]]
      }
    }, {
      "type": "Feature",
      "id": "IN.TR",
      "properties": {
        "hc-group": "admin1",
        "hc-middle-x": 0.51,
        "hc-middle-y": 0.46,
        "hc-key": "in-tr",
        "hc-a2": "TR",
        "labelrank": "2",
        "hasc": "IN.TR",
        "alt-name": null,
        "woe-id": "2345759",
        "subregion": null,
        "fips": "IN26",
        "postal-code": "TR",
        "name": "Tripura",
        "country": "India",
        "type-en": "State",
        "region": "Northeast",
        "longitude": "91.70310000000001",
        "woe-name": "Tripura",
        "latitude": "23.8519",
        "woe-label": "Tripura, IN, India",
        "type": "State"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [[[6988, 5349], [6999, 5332], [7006, 5209], [6991, 5154], [6954, 5161], [6907, 5127], [6882, 5153], [6890, 5070], [6844, 5020], [6830, 4984], [6853, 4919], [6786, 4862], [6739, 4945], [6706, 4971], [6711, 4899], [6686, 4926], [6653, 5043], [6620, 5093], [6637, 5202], [6676, 5236], [6681, 5275], [6746, 5276], [6765, 5319], [6800, 5333], [6846, 5306], [6860, 5377], [6920, 5405], [6930, 5455], [6970, 5405], [6961, 5356], [6988, 5349]]]
      }
    }, {
      "type": "Feature",
      "id": "IN.MP",
      "properties": {
        "hc-group": "admin1",
        "hc-middle-x": 0.47,
        "hc-middle-y": 0.61,
        "hc-key": "in-mp",
        "hc-a2": "MP",
        "labelrank": "2",
        "hasc": "IN.MP",
        "alt-name": null,
        "woe-id": "2345749",
        "subregion": null,
        "fips": "IN35",
        "postal-code": "MP",
        "name": "Madhya Pradesh",
        "country": "India",
        "type-en": "State",
        "region": "Central",
        "longitude": "78.42140000000001",
        "woe-name": "Madhya Pradesh",
        "latitude": "22.9404",
        "woe-label": "Madhya Pradesh, IN, India",
        "type": "State"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [[[964, 4430], [970, 4473], [949, 4519], [952, 4572], [1003, 4572], [938, 4622], [984, 4633], [1058, 4678], [1088, 4732], [1058, 4759], [1047, 4817], [1098, 4824], [1180, 4863], [1121, 4891], [1134, 4933], [1220, 4977], [1262, 5042], [1255, 5118], [1277, 5166], [1247, 5241], [1203, 5251], [1243, 5313], [1200, 5346], [1226, 5397], [1286, 5404], [1290, 5437], [1246, 5443], [1244, 5492], [1294, 5464], [1328, 5472], [1347, 5526], [1409, 5529], [1398, 5469], [1364, 5473], [1365, 5411], [1445, 5400], [1548, 5423], [1582, 5327], [1535, 5296], [1555, 5253], [1536, 5212], [1554, 5186], [1527, 5144], [1465, 5161], [1448, 5126], [1481, 5080], [1515, 5070], [1541, 5102], [1607, 5125], [1617, 5159], [1657, 5188], [1664, 5258], [1696, 5238], [1770, 5231], [1798, 5212], [1834, 5245], [1871, 5190], [1913, 5218], [1889, 5261], [1888, 5332], [1920, 5310], [1971, 5331], [1943, 5395], [1883, 5433], [1917, 5453], [1911, 5502], [2019, 5533], [2069, 5527], [2089, 5561], [2068, 5645], [2019, 5610], [1932, 5601], [1847, 5629], [1815, 5659], [1795, 5753], [1818, 5798], [1878, 5820], [1939, 5884], [2038, 5932], [2076, 5971], [2111, 5978], [2242, 6047], [2266, 6078], [2323, 6083], [2331, 6123], [2363, 6133], [2418, 6141], [2479, 6107], [2526, 6121], [2595, 6086], [2637, 5960], [2605, 5933], [2601, 5872], [2552, 5777], [2530, 5759], [2520, 5700], [2408, 5676], [2372, 5626], [2404, 5545], [2393, 5486], [2337, 5431], [2366, 5369], [2355, 5312], [2404, 5228], [2439, 5266], [2537, 5195], [2600, 5284], [2561, 5346], [2520, 5345], [2521, 5410], [2492, 5464], [2483, 5525], [2453, 5573], [2481, 5625], [2526, 5602], [2524, 5653], [2547, 5628], [2581, 5667], [2595, 5634], [2575, 5538], [2625, 5568], [2619, 5537], [2698, 5532], [2707, 5566], [2750, 5565], [2721, 5526], [2738, 5499], [2787, 5535], [2892, 5526], [2889, 5560], [2999, 5619], [3030, 5619], [3074, 5535], [3030, 5476], [3104, 5485], [3086, 5512], [3217, 5537], [3190, 5460], [3264, 5458], [3295, 5437], [3323, 5460], [3342, 5530], [3437, 5542], [3453, 5499], [3529, 5483], [3550, 5443], [3677, 5395], [3690, 5340], [3729, 5371], [3842, 5355], [3831, 5313], [3842, 5254], [3832, 5192], [3812, 5179], [3855, 5115], [3844, 5090], [3767, 5034], [3617, 5042], [3571, 5056], [3519, 5041], [3467, 5065], [3489, 5001], [3458, 4955], [3475, 4927], [3508, 4949], [3569, 4932], [3590, 4898], [3656, 4859], [3637, 4790], [3576, 4770], [3574, 4735], [3524, 4702], [3517, 4634], [3476, 4593], [3402, 4552], [3377, 4574], [3322, 4567], [3302, 4501], [3270, 4465], [3255, 4415], [3236, 4431], [3207, 4378], [3208, 4341], [3172, 4293], [3169, 4207], [3155, 4164], [3065, 4178], [3065, 4206], [2990, 4267], [2929, 4235], [2874, 4230], [2860, 4250], [2777, 4237], [2732, 4287], [2674, 4296], [2665, 4275], [2567, 4247], [2560, 4225], [2491, 4213], [2401, 4227], [2381, 4269], [2267, 4204], [2160, 4185], [2085, 4192], [2067, 4230], [2108, 4245], [2109, 4300], [2079, 4327], [2036, 4329], [1997, 4304], [1963, 4313], [1853, 4263], [1830, 4205], [1797, 4180], [1789, 4131], [1729, 4098], [1644, 4093], [1613, 4195], [1544, 4209], [1428, 4203], [1353, 4209], [1293, 4231], [1267, 4274], [1216, 4297], [1153, 4299], [1089, 4344], [1084, 4423], [1059, 4452], [989, 4419], [964, 4430]]]
      }
    }, {
      "type": "Feature",
      "id": "IN.CT",
      "properties": {
        "hc-group": "admin1",
        "hc-middle-x": 0.51,
        "hc-middle-y": 0.34,
        "hc-key": "in-ct",
        "hc-a2": "CT",
        "labelrank": "2",
        "hasc": "IN.CT",
        "alt-name": null,
        "woe-id": "20070464",
        "subregion": null,
        "fips": "IN37",
        "postal-code": "CT",
        "name": "Chhattisgarh",
        "country": "India",
        "type-en": "State",
        "region": "Central",
        "longitude": "82.3069",
        "woe-name": "Chhattisgarh",
        "latitude": "21.8044",
        "woe-label": "Chhattisgarh, IN, India",
        "type": "State"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [[[3155, 4164], [3169, 4207], [3172, 4293], [3208, 4341], [3207, 4378], [3236, 4431], [3255, 4415], [3270, 4465], [3302, 4501], [3322, 4567], [3377, 4574], [3402, 4552], [3476, 4593], [3517, 4634], [3524, 4702], [3574, 4735], [3576, 4770], [3637, 4790], [3656, 4859], [3590, 4898], [3569, 4932], [3508, 4949], [3475, 4927], [3458, 4955], [3489, 5001], [3467, 5065], [3519, 5041], [3571, 5056], [3617, 5042], [3767, 5034], [3844, 5090], [3855, 5115], [3909, 5085], [3989, 5097], [4031, 5168], [4092, 5143], [4104, 5096], [4151, 5055], [4180, 4973], [4222, 4966], [4245, 4994], [4258, 4962], [4237, 4896], [4259, 4901], [4266, 4816], [4295, 4764], [4367, 4756], [4375, 4725], [4323, 4658], [4251, 4599], [4260, 4563], [4131, 4473], [4103, 4390], [4117, 4344], [4089, 4333], [4042, 4222], [4054, 4164], [4027, 4172], [4001, 4105], [3961, 4083], [3922, 4106], [3823, 4096], [3788, 4024], [3752, 3985], [3714, 3990], [3714, 3881], [3742, 3835], [3741, 3706], [3808, 3678], [3836, 3683], [3843, 3631], [3796, 3599], [3797, 3626], [3730, 3641], [3700, 3623], [3678, 3667], [3580, 3718], [3539, 3653], [3611, 3601], [3612, 3508], [3659, 3462], [3657, 3367], [3679, 3329], [3651, 3233], [3593, 3210], [3574, 3160], [3516, 3093], [3448, 3058], [3415, 2921], [3398, 2895], [3313, 2906], [3278, 2884], [3258, 2907], [3241, 2995], [3185, 3047], [3159, 3112], [3093, 3179], [3041, 3177], [3014, 3220], [3039, 3269], [3015, 3315], [3060, 3412], [3119, 3462], [3169, 3417], [3206, 3446], [3227, 3495], [3165, 3534], [3106, 3612], [3083, 3596], [3068, 3642], [3104, 3652], [3104, 3728], [3069, 3733], [3068, 3764], [3135, 3797], [3135, 3895], [3093, 3893], [3119, 3930], [3112, 4009], [3073, 4038], [3089, 4098], [3137, 4125], [3155, 4164]]]
      }
    }, {
      "type": "Feature",
      "id": "IN.AR",
      "properties": {
        "hc-group": "admin1",
        "hc-middle-x": 0.53,
        "hc-middle-y": 0.39,
        "hc-key": "in-ar",
        "hc-a2": "AR",
        "labelrank": "2",
        "hasc": "IN.AR",
        "alt-name": "Agence de la Frontisre du Nord-Est(French-obsolete)|North East Frontier Agency",
        "woe-id": "2345763",
        "subregion": null,
        "fips": "IN30",
        "postal-code": "AR",
        "name": "Arunachal Pradesh",
        "country": "India",
        "type-en": "State",
        "region": "Northeast",
        "longitude": "94.46729999999999",
        "woe-name": "Arunachal Pradesh",
        "latitude": "28.4056",
        "woe-label": "Arunachal Pradesh, IN, India",
        "type": "State"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [[[7837, 6459], [7913, 6507], [7948, 6560], [7981, 6548], [8064, 6575], [8094, 6612], [8081, 6642], [8055, 6620], [8046, 6677], [8003, 6731], [8051, 6840], [7971, 6829], [7919, 6790], [7845, 6778], [7586, 6637], [7509, 6648], [7513, 6604], [7397, 6471], [7395, 6433], [7355, 6396], [7281, 6367], [7252, 6379], [7138, 6355], [7068, 6384], [6876, 6316], [6833, 6315], [6798, 6399], [6822, 6454], [6782, 6512], [6711, 6485], [6657, 6528], [6662, 6606], [6773, 6604], [6801, 6631], [6877, 6635], [6977, 6692], [6996, 6739], [6979, 6762], [7039, 6799], [7110, 6870], [7126, 6919], [7212, 6993], [7269, 6999], [7423, 7099], [7486, 7153], [7458, 7177], [7494, 7221], [7535, 7235], [7564, 7270], [7617, 7220], [7674, 7228], [7783, 7199], [7788, 7230], [7853, 7237], [7874, 7283], [7915, 7276], [7918, 7322], [8044, 7349], [8070, 7311], [8111, 7325], [8109, 7285], [8067, 7256], [8077, 7227], [8124, 7259], [8211, 7163], [8222, 7128], [8175, 7085], [8203, 7018], [8215, 7080], [8261, 7088], [8360, 7005], [8406, 7025], [8481, 6980], [8478, 6934], [8505, 6900], [8501, 6862], [8465, 6859], [8364, 6741], [8385, 6665], [8474, 6572], [8440, 6554], [8375, 6582], [8340, 6634], [8284, 6632], [8262, 6606], [8143, 6578], [8104, 6549], [8070, 6484], [8035, 6468], [7982, 6398], [7949, 6389], [7922, 6342], [7876, 6321], [7853, 6399], [7837, 6459]]]
      }
    }, {
      "type": "Feature",
      "id": "IN.ML",
      "properties": {
        "hc-group": "admin1",
        "hc-middle-x": 0.30,
        "hc-middle-y": 0.76,
        "hc-key": "in-ml",
        "hc-a2": "ML",
        "labelrank": "2",
        "hasc": "IN.ML",
        "alt-name": null,
        "woe-id": "2345752",
        "subregion": null,
        "fips": "IN18",
        "postal-code": "ML",
        "name": "Meghalaya",
        "country": "India",
        "type-en": "State",
        "region": "Northeast",
        "longitude": "91.3031",
        "woe-name": "Meghalaya",
        "latitude": "25.4804",
        "woe-label": "Meghalaya, IN, India",
        "type": "State"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [[[6994, 5629], [6965, 5652], [6862, 5683], [6688, 5652], [6609, 5670], [6474, 5638], [6446, 5646], [6324, 5630], [6170, 5673], [6146, 5666], [6134, 5722], [6194, 5780], [6172, 5816], [6179, 5857], [6228, 5917], [6304, 5943], [6361, 5935], [6361, 5909], [6434, 5932], [6502, 5932], [6524, 5894], [6577, 5910], [6585, 5863], [6632, 5905], [6668, 5915], [6699, 5978], [6745, 5960], [6776, 6007], [6810, 5991], [6887, 6016], [6920, 6007], [6900, 5875], [6969, 5905], [7044, 5847], [7045, 5815], [7116, 5766], [7125, 5722], [7048, 5688], [6994, 5629]]]
      }
    }, {
      "type": "Feature",
      "id": "IN.KL",
      "properties": {
        "hc-group": "admin1",
        "hc-middle-x": 0.74,
        "hc-middle-y": 0.64,
        "hc-key": "in-kl",
        "hc-a2": "KL",
        "labelrank": "2",
        "hasc": "IN.KL",
        "alt-name": null,
        "woe-id": "2345747",
        "subregion": null,
        "fips": "IN13",
        "postal-code": "KL",
        "name": "Kerala",
        "country": "India",
        "type-en": "State",
        "region": "South",
        "longitude": "76.52370000000001",
        "woe-name": "Kerala",
        "latitude": "10.3666",
        "woe-label": "Kerala, IN, India",
        "type": "State"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [[[1226, 847], [1135, 1035], [1102, 1117], [1134, 1120], [1191, 1067], [1247, 1055], [1287, 944], [1370, 873], [1416, 860], [1446, 818], [1520, 821], [1645, 712], [1618, 685], [1583, 690], [1588, 645], [1641, 630], [1688, 593], [1652, 550], [1722, 546], [1766, 490], [1738, 448], [1784, 426], [1808, 392], [1783, 339], [1789, 224], [1840, 194], [1913, 237], [1943, 186], [1924, 131], [1936, 97], [1909, -28], [1963, -40], [1983, -69], [1931, -204], [1898, -247], [1928, -298], [1902, -357], [1937, -418], [1896, -496], [1876, -503], [1836, -473], [1682, -284], [1614, -128], [1597, -67], [1580, 74], [1634, 0], [1616, 84], [1575, 111], [1510, 301], [1465, 392], [1435, 511], [1389, 628], [1361, 648], [1332, 727], [1255, 814], [1255, 854], [1288, 890], [1226, 875], [1226, 847]]]
      }
    }, {
      "type": "Feature",
      "id": "IN.TN",
      "properties": {
        "hc-group": "admin1",
        "hc-middle-x": 0.59,
        "hc-middle-y": 0.40,
        "hc-key": "in-tn",
        "hc-a2": "TN",
        "labelrank": "2",
        "hasc": "IN.",
        "alt-name": null,
        "woe-id": "2345758",
        "subregion": null,
        "fips": "IN22",
        "postal-code": "TN",
        "name": "Tamil Nadu",
        "country": "India",
        "type-en": "State",
        "region": "South",
        "longitude": "78.2704",
        "woe-name": "Tamil Nadu",
        "latitude": "11.0159",
        "woe-label": "Tamil Nadu, IN, India",
        "type": "State"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [[[1645, 712], [1788, 695], [1820, 757], [1881, 741], [1944, 761], [2006, 759], [2026, 799], [2090, 815], [2125, 868], [2090, 898], [2028, 900], [2074, 998], [2056, 1026], [2071, 1066], [2104, 1069], [2140, 1131], [2229, 1126], [2290, 1095], [2356, 1049], [2414, 1100], [2436, 1177], [2462, 1198], [2542, 1212], [2618, 1194], [2649, 1231], [2709, 1256], [2716, 1292], [2796, 1281], [2837, 1257], [2848, 1282], [2947, 1342], [3004, 1344], [3020, 1334], [3010, 1359], [3010, 1360], [3013, 1365], [3020, 1334], [3027, 1330], [3029, 1247], [3012, 1200], [2992, 1060], [2966, 988], [2862, 827], [2857, 803], [2800, 819], [2806, 768], [2844, 759], [2822, 668], [2834, 614], [2802, 570], [2851, 584], [2855, 454], [2816, 456], [2805, 429], [2855, 393], [2856, 205], [2762, 227], [2695, 220], [2638, 164], [2653, 117], [2625, 94], [2546, -14], [2522, -83], [2566, -140], [2642, -150], [2666, -138], [2703, -197], [2656, -164], [2537, -154], [2416, -202], [2356, -210], [2281, -263], [2236, -373], [2240, -434], [2216, -475], [2019, -580], [1949, -561], [1876, -503], [1896, -496], [1937, -418], [1902, -357], [1928, -298], [1898, -247], [1931, -204], [1983, -69], [1963, -40], [1909, -28], [1936, 97], [1924, 131], [1943, 186], [1913, 237], [1840, 194], [1789, 224], [1783, 339], [1808, 392], [1738, 448], [1766, 490], [1722, 546], [1652, 550], [1688, 593], [1641, 630], [1588, 645], [1583, 690], [1645, 712]]]
      }
    }, {
      "type": "Feature",
      "id": "IN.AP",
      "properties": {
        "hc-group": "admin1",
        "hc-middle-x": 0.26,
        "hc-middle-y": 0.56,
        "hc-key": "in-ap",
        "hc-a2": "AP",
        "labelrank": "2",
        "hasc": "IN.AP",
        "alt-name": null,
        "woe-id": "2345740",
        "subregion": null,
        "fips": "IN02",
        "postal-code": "AP",
        "name": "Andhra Pradesh",
        "country": "India",
        "type-en": "State",
        "region": "South",
        "longitude": "79.208",
        "woe-name": "Andhra Pradesh",
        "latitude": "16.4854",
        "woe-label": "Andhra Pradesh, IN, India",
        "type": "State"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [[[3010, 1359], [2962, 1437], [2931, 1398], [2954, 1355], [3004, 1344], [2947, 1342], [2848, 1282], [2837, 1257], [2796, 1281], [2716, 1292], [2709, 1256], [2649, 1231], [2618, 1194], [2542, 1212], [2462, 1198], [2436, 1177], [2414, 1100], [2356, 1049], [2290, 1095], [2295, 1129], [2356, 1162], [2409, 1258], [2334, 1315], [2342, 1392], [2277, 1397], [2246, 1430], [2225, 1499], [2186, 1480], [2192, 1527], [2141, 1520], [2141, 1497], [2072, 1450], [2018, 1436], [1998, 1488], [1914, 1512], [1910, 1467], [1849, 1467], [1868, 1511], [1819, 1601], [1854, 1607], [1863, 1569], [1904, 1546], [1966, 1547], [2004, 1506], [1982, 1590], [2029, 1611], [1956, 1663], [1916, 1667], [1882, 1628], [1834, 1638], [1818, 1686], [1843, 1707], [1782, 1749], [1779, 1786], [1808, 1876], [1773, 1902], [1789, 1939], [1880, 1906], [1916, 1950], [1909, 2013], [1882, 2029], [1863, 2084], [1905, 2142], [1889, 2217], [1927, 2247], [2032, 2242], [2045, 2260], [2051, 2394], [1970, 2421], [2031, 2472], [2025, 2518], [2045, 2633], [2015, 2698], [2125, 2819], [2095, 2813], [2031, 2844], [2071, 2884], [2063, 2908], [2104, 2948], [2083, 3085], [2067, 3112], [2099, 3171], [2129, 3179], [2141, 3221], [2210, 3272], [2157, 3349], [2185, 3375], [2210, 3449], [2300, 3424], [2303, 3464], [2347, 3502], [2381, 3592], [2358, 3648], [2408, 3614], [2427, 3623], [2510, 3605], [2577, 3531], [2642, 3557], [2727, 3516], [2834, 3539], [2900, 3496], [2911, 3467], [2900, 3342], [2908, 3275], [2893, 3261], [2952, 3215], [3014, 3220], [3041, 3177], [3093, 3179], [3159, 3112], [3185, 3047], [3241, 2995], [3258, 2907], [3278, 2884], [3313, 2906], [3398, 2895], [3461, 2892], [3579, 2965], [3619, 2981], [3687, 2963], [3718, 2982], [3710, 3035], [3730, 3114], [3757, 3153], [3808, 3083], [3805, 3054], [3871, 3095], [3959, 3108], [3974, 3156], [3954, 3197], [3988, 3240], [4013, 3234], [4078, 3281], [4046, 3324], [4097, 3317], [4151, 3375], [4195, 3304], [4217, 3330], [4252, 3261], [4341, 3255], [4394, 3264], [4463, 3346], [4520, 3393], [4548, 3377], [4511, 3310], [4431, 3203], [4337, 3108], [4315, 3070], [4157, 2987], [4107, 2935], [4031, 2823], [3914, 2756], [3853, 2734], [3770, 2682], [3710, 2619], [3699, 2560], [3732, 2558], [3714, 2458], [3605, 2396], [3526, 2365], [3405, 2386], [3348, 2363], [3316, 2244], [3262, 2194], [3225, 2211], [3196, 2147], [3185, 2207], [3108, 2206], [3041, 2169], [3007, 2133], [2947, 2001], [2934, 1897], [2953, 1786], [2983, 1736], [2958, 1626], [2971, 1530], [2996, 1476], [2990, 1425], [3013, 1365], [3010, 1360], [3010, 1359]], [[3693, 2498], [3711, 2512], [3687, 2507], [3669, 2507], [3693, 2498]]]
      }
    }, {
      "type": "Feature",
      "id": "IN.KA",
      "properties": {
        "hc-group": "admin1",
        "hc-middle-x": 0.40,
        "hc-middle-y": 0.62,
        "hc-key": "in-ka",
        "hc-a2": "KA",
        "labelrank": "2",
        "hasc": "IN.KA",
        "alt-name": "Maisur|Mysore",
        "woe-id": "2345753",
        "subregion": null,
        "fips": "IN19",
        "postal-code": "KA",
        "name": "Karnataka",
        "country": "India",
        "type-en": "State",
        "region": "South",
        "longitude": "75.667",
        "woe-name": "Karnataka",
        "latitude": "14.3681",
        "woe-label": "Karnataka, IN, India",
        "type": "State"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [[[1645, 712], [1520, 821], [1446, 818], [1416, 860], [1370, 873], [1287, 944], [1247, 1055], [1191, 1067], [1134, 1120], [1102, 1117], [1089, 1152], [1046, 1393], [1017, 1529], [990, 1568], [954, 1732], [924, 1756], [912, 1819], [855, 1854], [854, 1888], [907, 1911], [931, 2025], [910, 2154], [866, 2159], [897, 2203], [948, 2200], [1000, 2324], [996, 2376], [954, 2387], [961, 2425], [927, 2481], [965, 2481], [993, 2517], [1032, 2483], [1074, 2500], [1082, 2537], [1142, 2553], [1139, 2587], [1180, 2621], [1250, 2589], [1282, 2621], [1407, 2623], [1418, 2664], [1389, 2772], [1411, 2801], [1469, 2765], [1499, 2779], [1521, 2746], [1616, 2766], [1661, 2752], [1656, 2847], [1723, 2901], [1779, 2876], [1853, 2971], [1857, 3032], [1924, 3049], [1999, 3142], [2044, 3077], [2083, 3085], [2104, 2948], [2063, 2908], [2071, 2884], [2031, 2844], [2095, 2813], [2125, 2819], [2015, 2698], [2045, 2633], [2025, 2518], [2031, 2472], [1970, 2421], [2051, 2394], [2045, 2260], [2032, 2242], [1927, 2247], [1889, 2217], [1905, 2142], [1863, 2084], [1882, 2029], [1909, 2013], [1916, 1950], [1880, 1906], [1789, 1939], [1773, 1902], [1808, 1876], [1779, 1786], [1782, 1749], [1843, 1707], [1818, 1686], [1834, 1638], [1882, 1628], [1916, 1667], [1956, 1663], [2029, 1611], [1982, 1590], [2004, 1506], [1966, 1547], [1904, 1546], [1863, 1569], [1854, 1607], [1819, 1601], [1868, 1511], [1849, 1467], [1910, 1467], [1914, 1512], [1998, 1488], [2018, 1436], [2072, 1450], [2141, 1497], [2141, 1520], [2192, 1527], [2186, 1480], [2225, 1499], [2246, 1430], [2277, 1397], [2342, 1392], [2334, 1315], [2409, 1258], [2356, 1162], [2295, 1129], [2290, 1095], [2229, 1126], [2140, 1131], [2104, 1069], [2071, 1066], [2056, 1026], [2074, 998], [2028, 900], [2090, 898], [2125, 868], [2090, 815], [2026, 799], [2006, 759], [1944, 761], [1881, 741], [1820, 757], [1788, 695], [1645, 712]]]
      }
    }, {
      "type": "Feature",
      "id": "IN.MH",
      "properties": {
        "hc-group": "admin1",
        "hc-middle-x": 0.32,
        "hc-middle-y": 0.46,
        "hc-key": "in-mh",
        "hc-a2": "MH",
        "labelrank": "2",
        "hasc": "IN.MH",
        "alt-name": null,
        "woe-id": "2345750",
        "subregion": null,
        "fips": "IN16",
        "postal-code": "MH",
        "name": "Maharashtra",
        "country": "India",
        "type-en": "State",
        "region": "West",
        "longitude": "75.46469999999999",
        "woe-name": "Maharashtra",
        "latitude": "19.4723",
        "woe-label": "Maharashtra, IN, India",
        "type": "State"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [[[608, 3784], [645, 3810], [676, 3803], [679, 3872], [715, 3931], [685, 3970], [716, 3996], [773, 3938], [829, 3951], [871, 4010], [861, 4082], [804, 4138], [843, 4194], [883, 4196], [898, 4232], [1012, 4270], [913, 4289], [853, 4275], [832, 4313], [858, 4326], [855, 4394], [964, 4430], [989, 4419], [1059, 4452], [1084, 4423], [1089, 4344], [1153, 4299], [1216, 4297], [1267, 4274], [1293, 4231], [1353, 4209], [1428, 4203], [1544, 4209], [1613, 4195], [1644, 4093], [1729, 4098], [1789, 4131], [1797, 4180], [1830, 4205], [1853, 4263], [1963, 4313], [1997, 4304], [2036, 4329], [2079, 4327], [2109, 4300], [2108, 4245], [2067, 4230], [2085, 4192], [2160, 4185], [2267, 4204], [2381, 4269], [2401, 4227], [2491, 4213], [2560, 4225], [2567, 4247], [2665, 4275], [2674, 4296], [2732, 4287], [2777, 4237], [2860, 4250], [2874, 4230], [2929, 4235], [2990, 4267], [3065, 4206], [3065, 4178], [3155, 4164], [3137, 4125], [3089, 4098], [3073, 4038], [3112, 4009], [3119, 3930], [3093, 3893], [3135, 3895], [3135, 3797], [3068, 3764], [3069, 3733], [3104, 3728], [3104, 3652], [3068, 3642], [3083, 3596], [3106, 3612], [3165, 3534], [3227, 3495], [3206, 3446], [3169, 3417], [3119, 3462], [3060, 3412], [3015, 3315], [3039, 3269], [3014, 3220], [2952, 3215], [2893, 3261], [2908, 3275], [2900, 3342], [2911, 3467], [2900, 3496], [2834, 3539], [2727, 3516], [2642, 3557], [2577, 3531], [2510, 3605], [2427, 3623], [2408, 3614], [2358, 3648], [2381, 3592], [2347, 3502], [2303, 3464], [2300, 3424], [2210, 3449], [2185, 3375], [2157, 3349], [2210, 3272], [2141, 3221], [2129, 3179], [2099, 3171], [2067, 3112], [2083, 3085], [2044, 3077], [1999, 3142], [1924, 3049], [1857, 3032], [1853, 2971], [1779, 2876], [1723, 2901], [1656, 2847], [1661, 2752], [1616, 2766], [1521, 2746], [1499, 2779], [1469, 2765], [1411, 2801], [1389, 2772], [1418, 2664], [1407, 2623], [1282, 2621], [1250, 2589], [1180, 2621], [1139, 2587], [1142, 2553], [1082, 2537], [1074, 2500], [1032, 2483], [993, 2517], [965, 2481], [927, 2481], [961, 2425], [954, 2387], [996, 2376], [1000, 2324], [948, 2200], [897, 2203], [866, 2159], [811, 2158], [772, 2214], [728, 2194], [644, 2321], [602, 2501], [598, 2688], [565, 2810], [555, 2922], [511, 3053], [512, 3112], [546, 3103], [491, 3158], [494, 3227], [478, 3304], [524, 3338], [495, 3348], [529, 3384], [462, 3382], [473, 3450], [427, 3694], [451, 3776], [473, 3785], [534, 3792], [549, 3759], [605, 3759], [608, 3784]]]
      }
    }, {
      "type": "Feature",
      "id": "IN.OR",
      "properties": {
        "hc-group": "admin1",
        "hc-middle-x": 0.49,
        "hc-middle-y": 0.44,
        "hc-key": "in-or",
        "hc-a2": "OR",
        "labelrank": "2",
        "hasc": "IN.OR",
        "alt-name": null,
        "woe-id": "2345755",
        "subregion": null,
        "fips": "IN21",
        "postal-code": "OR",
        "name": "Orissa",
        "country": "India",
        "type-en": "State",
        "region": "East",
        "longitude": "84.4341",
        "woe-name": "Orissa",
        "latitude": "20.625",
        "woe-label": "Orissa, IN, India",
        "type": "State"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [[[5160, 4509], [5268, 4451], [5289, 4403], [5333, 4422], [5363, 4372], [5408, 4364], [5434, 4303], [5342, 4277], [5297, 4247], [5250, 4192], [5225, 4136], [5285, 3957], [5212, 3898], [5196, 3816], [5121, 3777], [5091, 3703], [4984, 3650], [4871, 3619], [4772, 3580], [4810, 3614], [4811, 3656], [4775, 3665], [4694, 3603], [4655, 3528], [4690, 3525], [4708, 3575], [4752, 3588], [4735, 3547], [4682, 3509], [4548, 3377], [4520, 3393], [4463, 3346], [4394, 3264], [4341, 3255], [4252, 3261], [4217, 3330], [4195, 3304], [4151, 3375], [4097, 3317], [4046, 3324], [4078, 3281], [4013, 3234], [3988, 3240], [3954, 3197], [3974, 3156], [3959, 3108], [3871, 3095], [3805, 3054], [3808, 3083], [3757, 3153], [3730, 3114], [3710, 3035], [3718, 2982], [3687, 2963], [3619, 2981], [3579, 2965], [3461, 2892], [3398, 2895], [3415, 2921], [3448, 3058], [3516, 3093], [3574, 3160], [3593, 3210], [3651, 3233], [3679, 3329], [3657, 3367], [3659, 3462], [3612, 3508], [3611, 3601], [3539, 3653], [3580, 3718], [3678, 3667], [3700, 3623], [3730, 3641], [3797, 3626], [3796, 3599], [3843, 3631], [3836, 3683], [3808, 3678], [3741, 3706], [3742, 3835], [3714, 3881], [3714, 3990], [3752, 3985], [3788, 4024], [3823, 4096], [3922, 4106], [3961, 4083], [4001, 4105], [4027, 4172], [4054, 4164], [4042, 4222], [4089, 4333], [4117, 4344], [4103, 4390], [4131, 4473], [4260, 4563], [4251, 4599], [4311, 4545], [4402, 4527], [4438, 4561], [4564, 4564], [4616, 4594], [4625, 4514], [4593, 4453], [4634, 4453], [4672, 4426], [4739, 4476], [4825, 4447], [4862, 4467], [4861, 4425], [4905, 4430], [4923, 4460], [4924, 4564], [4907, 4602], [4940, 4623], [5051, 4546], [5092, 4550], [5160, 4509]]]
      }
    }, {
      "type": "Feature",
      "id": "IN.DN",
      "properties": {
        "hc-group": "admin1",
        "hc-middle-x": 0.52,
        "hc-middle-y": 0.60,
        "hc-key": "in-dn",
        "hc-a2": "DN",
        "labelrank": "9",
        "hasc": "IN.DN",
        "alt-name": "DAdra et Nagar Haveli|Dadra e Nagar Haveli",
        "woe-id": "20070457",
        "subregion": null,
        "fips": "IN06",
        "postal-code": "DN",
        "name": "Dadra and Nagar Haveli",
        "country": "India",
        "type-en": "Union Territory",
        "region": "West",
        "longitude": "73.029",
        "woe-name": "Dadra and Nagar Haveli",
        "latitude": "20.1841",
        "woe-label": "Dadra and Nagar Haveli, IN, India",
        "type": "Union Territor"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [[[608, 3784], [605, 3759], [549, 3759], [534, 3792], [518, 3827], [578, 3865], [608, 3784]]]
      }
    }, {
      "type": "Feature",
      "id": "IN.DL",
      "properties": {
        "hc-group": "admin1",
        "hc-middle-x": 0.60,
        "hc-middle-y": 0.46,
        "hc-key": "in-dl",
        "hc-a2": "DL",
        "labelrank": "9",
        "hasc": "IN.DL",
        "alt-name": null,
        "woe-id": "20070458",
        "subregion": null,
        "fips": "IN07",
        "postal-code": "DL",
        "name": "Delhi",
        "country": "India",
        "type-en": "Union Territory",
        "region": "Central",
        "longitude": "77.0856",
        "woe-name": "Delhi",
        "latitude": "28.69",
        "woe-label": "Delhi, IN, India",
        "type": "Union Territor"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [[[2100, 6748], [2057, 6718], [2019, 6754], [1956, 6753], [1945, 6772], [1982, 6815], [1980, 6858], [2022, 6881], [2064, 6878], [2096, 6820], [2100, 6748]]]
      }
    }, {
      "type": "Feature",
      "id": "IN.HP",
      "properties": {
        "hc-group": "admin1",
        "hc-middle-x": 0.38,
        "hc-middle-y": 0.41,
        "hc-key": "in-hp",
        "hc-a2": "HP",
        "labelrank": "2",
        "hasc": "IN.HP",
        "alt-name": null,
        "woe-id": "2345745",
        "subregion": null,
        "fips": "IN11",
        "postal-code": "HP",
        "name": "Himachal Pradesh",
        "country": "India",
        "type-en": "Union Territory",
        "region": "North",
        "longitude": "77.28749999999999",
        "woe-name": "Himachal Pradesh",
        "latitude": "31.6755",
        "woe-label": "Himachal Pradesh, IN, India",
        "type": "Union Territor"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [[[2201, 7414], [2083, 7460], [2062, 7485], [2059, 7540], [2025, 7561], [1997, 7606], [1954, 7611], [1917, 7645], [1901, 7729], [1857, 7762], [1840, 7799], [1808, 7762], [1772, 7773], [1749, 7855], [1708, 7944], [1721, 7959], [1697, 8005], [1608, 8052], [1645, 8115], [1715, 8169], [1697, 8201], [1721, 8236], [1720, 8292], [1690, 8338], [1741, 8340], [1817, 8387], [1843, 8421], [1924, 8447], [1978, 8433], [2041, 8369], [2094, 8331], [2158, 8308], [2272, 8356], [2312, 8305], [2355, 8209], [2465, 8262], [2466, 8220], [2433, 8169], [2467, 8177], [2488, 8136], [2488, 8069], [2573, 7972], [2549, 7903], [2593, 7843], [2556, 7809], [2575, 7786], [2567, 7746], [2610, 7733], [2644, 7672], [2606, 7669], [2582, 7700], [2493, 7707], [2427, 7733], [2350, 7693], [2320, 7694], [2259, 7623], [2270, 7609], [2243, 7559], [2273, 7461], [2195, 7426], [2201, 7414]]]
      }
    }, {
      "type": "Feature",
      "id": "IN.RJ",
      "properties": {
        "hc-group": "admin1",
        "hc-middle-x": 0.54,
        "hc-middle-y": 0.52,
        "hc-key": "in-rj",
        "hc-a2": "RJ",
        "labelrank": "2",
        "hasc": "IN.RJ",
        "alt-name": "Greater Rajasthan|Rajputana",
        "woe-id": "2345757",
        "subregion": null,
        "fips": "IN24",
        "postal-code": "RJ",
        "name": "Rajasthan",
        "country": "India",
        "type-en": "State",
        "region": "Central",
        "longitude": "73.8556",
        "woe-name": "Rajasthan",
        "latitude": "26.7468",
        "woe-label": "Rajasthan, IN, India",
        "type": "State"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [[[1237, 7299], [1245, 7268], [1218, 7227], [1257, 7234], [1254, 7126], [1233, 7117], [1255, 7077], [1322, 7098], [1400, 7034], [1480, 7052], [1514, 6952], [1552, 6813], [1609, 6734], [1642, 6723], [1700, 6638], [1655, 6620], [1681, 6606], [1650, 6562], [1669, 6520], [1738, 6517], [1722, 6582], [1732, 6601], [1818, 6630], [1816, 6592], [1847, 6560], [1879, 6600], [1947, 6649], [1973, 6610], [1958, 6448], [2010, 6471], [2001, 6496], [2077, 6494], [2095, 6397], [2130, 6340], [2176, 6317], [2192, 6273], [2140, 6234], [2203, 6196], [2126, 6168], [2103, 6127], [2204, 6175], [2291, 6163], [2334, 6178], [2378, 6166], [2363, 6133], [2331, 6123], [2323, 6083], [2266, 6078], [2242, 6047], [2111, 5978], [2076, 5971], [2038, 5932], [1939, 5884], [1878, 5820], [1818, 5798], [1795, 5753], [1815, 5659], [1847, 5629], [1932, 5601], [2019, 5610], [2068, 5645], [2089, 5561], [2069, 5527], [2019, 5533], [1911, 5502], [1917, 5453], [1883, 5433], [1943, 5395], [1971, 5331], [1920, 5310], [1888, 5332], [1889, 5261], [1913, 5218], [1871, 5190], [1834, 5245], [1798, 5212], [1770, 5231], [1696, 5238], [1664, 5258], [1657, 5188], [1617, 5159], [1607, 5125], [1541, 5102], [1515, 5070], [1481, 5080], [1448, 5126], [1465, 5161], [1527, 5144], [1554, 5186], [1536, 5212], [1555, 5253], [1535, 5296], [1582, 5327], [1548, 5423], [1445, 5400], [1365, 5411], [1364, 5473], [1398, 5469], [1409, 5529], [1347, 5526], [1328, 5472], [1294, 5464], [1244, 5492], [1246, 5443], [1290, 5437], [1286, 5404], [1226, 5397], [1200, 5346], [1243, 5313], [1203, 5251], [1247, 5241], [1277, 5166], [1255, 5118], [1262, 5042], [1220, 4977], [1134, 4933], [1121, 4891], [1180, 4863], [1098, 4824], [1047, 4817], [1019, 4862], [931, 4939], [884, 4969], [822, 4973], [823, 5025], [741, 5102], [765, 5158], [745, 5218], [707, 5188], [656, 5259], [678, 5305], [662, 5369], [636, 5365], [608, 5319], [550, 5329], [489, 5378], [453, 5354], [444, 5385], [328, 5462], [292, 5447], [160, 5466], [62, 5454], [-1, 5479], [-47, 5595], [-54, 5645], [-116, 5756], [-113, 5854], [-203, 5851], [-234, 5863], [-291, 5970], [-262, 6041], [-243, 6167], [-274, 6191], [-353, 6195], [-449, 6260], [-460, 6288], [-438, 6374], [-411, 6422], [-316, 6495], [-255, 6559], [-225, 6626], [-137, 6698], [-99, 6705], [-46, 6661], [-27, 6590], [11, 6572], [170, 6618], [250, 6614], [348, 6636], [362, 6688], [397, 6733], [452, 6775], [493, 6877], [537, 6924], [708, 6999], [825, 7176], [878, 7314], [996, 7350], [1064, 7402], [1070, 7378], [1041, 7324], [1237, 7299]]]
      }
    }, {
      "type": "Feature",
      "id": "IN.UP",
      "properties": {
        "hc-group": "admin1",
        "hc-middle-x": 0.42,
        "hc-middle-y": 0.53,
        "hc-key": "in-up",
        "hc-a2": "UP",
        "labelrank": "2",
        "hasc": "IN.UP",
        "alt-name": "United Provinces",
        "woe-id": "2345760",
        "subregion": null,
        "fips": "IN36",
        "postal-code": "UP",
        "name": "Uttar Pradesh",
        "country": "India",
        "type-en": "State",
        "region": "Central",
        "longitude": "80.9966",
        "woe-name": "Uttar Pradesh",
        "latitude": "26.7201",
        "woe-label": "Uttar Pradesh, IN, India",
        "type": "State"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [[[2363, 6133], [2378, 6166], [2334, 6178], [2291, 6163], [2204, 6175], [2103, 6127], [2126, 6168], [2203, 6196], [2140, 6234], [2192, 6273], [2176, 6317], [2130, 6340], [2095, 6397], [2077, 6494], [2158, 6543], [2140, 6577], [2161, 6651], [2152, 6701], [2100, 6748], [2096, 6820], [2064, 6878], [2048, 6969], [2054, 7067], [2027, 7122], [2068, 7210], [2086, 7272], [2195, 7377], [2201, 7414], [2225, 7418], [2312, 7355], [2247, 7267], [2271, 7152], [2310, 7174], [2357, 7148], [2383, 7166], [2374, 7245], [2397, 7252], [2443, 7185], [2474, 7170], [2524, 7103], [2610, 7060], [2547, 7011], [2592, 6986], [2606, 6946], [2651, 6962], [2726, 6896], [2749, 6895], [2772, 6852], [2810, 6862], [2897, 6852], [2932, 6809], [2970, 6839], [3057, 6767], [3102, 6751], [3104, 6785], [3151, 6766], [3263, 6686], [3309, 6678], [3360, 6589], [3388, 6602], [3408, 6572], [3544, 6491], [3597, 6512], [3710, 6431], [3789, 6442], [3822, 6367], [3944, 6351], [4000, 6312], [4017, 6359], [4090, 6358], [4175, 6320], [4205, 6277], [4249, 6171], [4304, 6154], [4307, 6112], [4352, 6072], [4260, 6073], [4204, 6008], [4288, 5985], [4292, 5945], [4229, 5925], [4254, 5877], [4319, 5816], [4356, 5821], [4407, 5794], [4431, 5753], [4394, 5736], [4357, 5758], [4314, 5715], [4282, 5745], [4206, 5670], [4039, 5561], [4023, 5538], [4034, 5427], [4083, 5392], [4089, 5309], [4050, 5297], [4068, 5248], [4031, 5168], [3989, 5097], [3909, 5085], [3855, 5115], [3812, 5179], [3832, 5192], [3842, 5254], [3831, 5313], [3842, 5355], [3729, 5371], [3690, 5340], [3677, 5395], [3550, 5443], [3529, 5483], [3453, 5499], [3437, 5542], [3342, 5530], [3323, 5460], [3295, 5437], [3264, 5458], [3190, 5460], [3217, 5537], [3086, 5512], [3104, 5485], [3030, 5476], [3074, 5535], [3030, 5619], [2999, 5619], [2889, 5560], [2892, 5526], [2787, 5535], [2738, 5499], [2721, 5526], [2750, 5565], [2707, 5566], [2698, 5532], [2619, 5537], [2625, 5568], [2575, 5538], [2595, 5634], [2581, 5667], [2547, 5628], [2524, 5653], [2526, 5602], [2481, 5625], [2453, 5573], [2483, 5525], [2492, 5464], [2521, 5410], [2520, 5345], [2561, 5346], [2600, 5284], [2537, 5195], [2439, 5266], [2404, 5228], [2355, 5312], [2366, 5369], [2337, 5431], [2393, 5486], [2404, 5545], [2372, 5626], [2408, 5676], [2520, 5700], [2530, 5759], [2552, 5777], [2601, 5872], [2605, 5933], [2637, 5960], [2595, 6086], [2526, 6121], [2479, 6107], [2418, 6141], [2363, 6133]]]
      }
    }, {
      "type": "Feature",
      "id": "IN.UT",
      "properties": {
        "hc-group": "admin1",
        "hc-middle-x": 0.45,
        "hc-middle-y": 0.46,
        "hc-key": "in-ut",
        "hc-a2": "UT",
        "labelrank": "2",
        "hasc": "IN.UT",
        "alt-name": "Uttarakhand",
        "woe-id": "20070462",
        "subregion": null,
        "fips": "IN39",
        "postal-code": "UT",
        "name": "Uttaranchal",
        "country": "India",
        "type-en": "State",
        "region": "Central",
        "longitude": "79.2841",
        "woe-name": "Uttaranchal",
        "latitude": "30.0576",
        "woe-label": "Uttarakhand, IN, India",
        "type": "State"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [[[2201, 7414], [2195, 7426], [2273, 7461], [2243, 7559], [2270, 7609], [2259, 7623], [2320, 7694], [2350, 7693], [2427, 7733], [2493, 7707], [2582, 7700], [2606, 7669], [2644, 7672], [2610, 7733], [2640, 7740], [2667, 7780], [2708, 7740], [2737, 7668], [2769, 7631], [2823, 7600], [2902, 7607], [2972, 7543], [3025, 7521], [3008, 7462], [3053, 7457], [3177, 7401], [3195, 7376], [3264, 7337], [3216, 7312], [3155, 7250], [3129, 7242], [3099, 7192], [3065, 7175], [3070, 7120], [3016, 7053], [3036, 7014], [3021, 6953], [2990, 6943], [2958, 6874], [2970, 6839], [2932, 6809], [2897, 6852], [2810, 6862], [2772, 6852], [2749, 6895], [2726, 6896], [2651, 6962], [2606, 6946], [2592, 6986], [2547, 7011], [2610, 7060], [2524, 7103], [2474, 7170], [2443, 7185], [2397, 7252], [2374, 7245], [2383, 7166], [2357, 7148], [2310, 7174], [2271, 7152], [2247, 7267], [2312, 7355], [2225, 7418], [2201, 7414]]]
      }
    }, {
      "type": "Feature",
      "id": "IN.JH",
      "properties": {
        "hc-group": "admin1",
        "hc-middle-x": 0.45,
        "hc-middle-y": 0.58,
        "hc-key": "in-jh",
        "hc-a2": "JH",
        "labelrank": "2",
        "hasc": "IN.JH",
        "alt-name": "Vananchal",
        "woe-id": "20070463",
        "subregion": null,
        "fips": "IN38",
        "postal-code": "JH",
        "name": "Jharkhand",
        "country": "India",
        "type-en": "State",
        "region": "East",
        "longitude": "85.05840000000001",
        "woe-name": "Jharkhand",
        "latitude": "23.5221",
        "woe-label": "Jharkhand, IN, India",
        "type": "State"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [[[4031, 5168], [4068, 5248], [4050, 5297], [4089, 5309], [4146, 5302], [4219, 5316], [4259, 5346], [4277, 5304], [4346, 5315], [4348, 5286], [4402, 5236], [4463, 5262], [4508, 5307], [4563, 5255], [4702, 5317], [4747, 5316], [4790, 5341], [4784, 5370], [4815, 5414], [4871, 5391], [4905, 5408], [4952, 5342], [4997, 5342], [4994, 5300], [5049, 5269], [5094, 5350], [5149, 5362], [5194, 5343], [5202, 5373], [5246, 5369], [5262, 5504], [5309, 5543], [5316, 5580], [5353, 5584], [5389, 5638], [5476, 5602], [5477, 5558], [5514, 5488], [5518, 5379], [5476, 5379], [5494, 5346], [5471, 5279], [5442, 5260], [5454, 5231], [5397, 5206], [5399, 5178], [5330, 5146], [5321, 5104], [5268, 5089], [5199, 5121], [5176, 5052], [5065, 5017], [5026, 4968], [4987, 4946], [4957, 4991], [4922, 5000], [4914, 4966], [4858, 4953], [4881, 4930], [4861, 4874], [4882, 4839], [4926, 4837], [4968, 4794], [5071, 4789], [5057, 4709], [5121, 4674], [5130, 4647], [5177, 4628], [5167, 4600], [5213, 4545], [5160, 4509], [5092, 4550], [5051, 4546], [4940, 4623], [4907, 4602], [4924, 4564], [4923, 4460], [4905, 4430], [4861, 4425], [4862, 4467], [4825, 4447], [4739, 4476], [4672, 4426], [4634, 4453], [4593, 4453], [4625, 4514], [4616, 4594], [4564, 4564], [4438, 4561], [4402, 4527], [4311, 4545], [4251, 4599], [4323, 4658], [4375, 4725], [4367, 4756], [4295, 4764], [4266, 4816], [4259, 4901], [4237, 4896], [4258, 4962], [4245, 4994], [4222, 4966], [4180, 4973], [4151, 5055], [4104, 5096], [4092, 5143], [4031, 5168]]]
      }
    }, {
      "type": "Feature",
      "id": "IN.CH",
      "properties": {
        "hc-group": "admin1",
        "hc-middle-x": 0.74,
        "hc-middle-y": 0.29,
        "hc-key": "in-ch",
        "hc-a2": "CH",
        "labelrank": "9",
        "hasc": "IN.CH",
        "alt-name": null,
        "woe-id": "20070456",
        "subregion": null,
        "fips": "IN05",
        "postal-code": "CH",
        "name": "Chandigarh",
        "country": "India",
        "type-en": "Union Territory",
        "region": "North",
        "longitude": "76.76049999999999",
        "woe-name": "Chandigarh",
        "latitude": "30.7452",
        "woe-label": "Chandigarh, IN, India",
        "type": "Union Territor"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [[[1967, 7568], [1970, 7548], [1969, 7529], [1933, 7566], [1967, 7568]]]
      }
    }, {
      "type": "Feature",
      "id": "IN.BR",
      "properties": {
        "hc-group": "admin1",
        "hc-middle-x": 0.44,
        "hc-middle-y": 0.59,
        "hc-key": "in-br",
        "hc-a2": "BR",
        "labelrank": "2",
        "hasc": "IN.BR",
        "alt-name": null,
        "woe-id": "2345742",
        "subregion": null,
        "fips": "IN34",
        "postal-code": "BR",
        "name": "Bihar",
        "country": "India",
        "type-en": "State",
        "region": "East",
        "longitude": "85.8134",
        "woe-name": "Bihar",
        "latitude": "25.6853",
        "woe-label": "Bihar, IN, India",
        "type": "State"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [[[5476, 5602], [5389, 5638], [5353, 5584], [5316, 5580], [5309, 5543], [5262, 5504], [5246, 5369], [5202, 5373], [5194, 5343], [5149, 5362], [5094, 5350], [5049, 5269], [4994, 5300], [4997, 5342], [4952, 5342], [4905, 5408], [4871, 5391], [4815, 5414], [4784, 5370], [4790, 5341], [4747, 5316], [4702, 5317], [4563, 5255], [4508, 5307], [4463, 5262], [4402, 5236], [4348, 5286], [4346, 5315], [4277, 5304], [4259, 5346], [4219, 5316], [4146, 5302], [4089, 5309], [4083, 5392], [4034, 5427], [4023, 5538], [4039, 5561], [4206, 5670], [4282, 5745], [4314, 5715], [4357, 5758], [4394, 5736], [4431, 5753], [4407, 5794], [4356, 5821], [4319, 5816], [4254, 5877], [4229, 5925], [4292, 5945], [4288, 5985], [4204, 6008], [4260, 6073], [4352, 6072], [4307, 6112], [4304, 6154], [4249, 6171], [4205, 6277], [4175, 6320], [4169, 6352], [4224, 6355], [4246, 6381], [4315, 6335], [4407, 6320], [4434, 6276], [4431, 6213], [4523, 6190], [4554, 6151], [4600, 6155], [4642, 6115], [4741, 6161], [4770, 6146], [4780, 6090], [4816, 6062], [4877, 6094], [4939, 6071], [4965, 6082], [5107, 6017], [5210, 6082], [5226, 6029], [5306, 6005], [5324, 6029], [5390, 6018], [5481, 6052], [5516, 6020], [5549, 6084], [5584, 6090], [5623, 6024], [5522, 5941], [5477, 5890], [5471, 5840], [5553, 5770], [5563, 5707], [5526, 5720], [5459, 5670], [5492, 5626], [5476, 5602]]]
      }
    }, {
      "type": "Feature",
      "id": "IN.SK",
      "properties": {
        "hc-group": "admin1",
        "hc-middle-x": 0.45,
        "hc-middle-y": 0.51,
        "hc-key": "in-sk",
        "hc-a2": "SK",
        "labelrank": "2",
        "hasc": "IN.SK",
        "alt-name": null,
        "woe-id": "2345762",
        "subregion": null,
        "fips": "IN29",
        "postal-code": "SK",
        "name": "Sikkim",
        "country": "India",
        "type-en": "State",
        "region": "East",
        "longitude": "88.4482",
        "woe-name": "Sikkim",
        "latitude": "27.5709",
        "woe-label": "Sikkim, IN, India",
        "type": "State"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [[[5745, 6316], [5675, 6322], [5630, 6286], [5547, 6301], [5508, 6338], [5509, 6427], [5547, 6530], [5529, 6591], [5613, 6609], [5684, 6658], [5753, 6622], [5768, 6569], [5739, 6459], [5752, 6410], [5792, 6379], [5745, 6316]]]
      }
    }]
  }


}));
